export default "__VITE_ASSET__BQKHkW5Y__"